import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container } from 'react-bootstrap';
import blogImage4 from './blog4.png';

const BlogDetailPage2 = ({ onBack }) => {
    const navigate = useNavigate();

    const blogTitle = "10 Must‑Have Features for Your Small Business Website in 2025";

    return (
        <Container>
            <Button onClick={onBack}
                className="mb-4"
                style={{
                    backgroundColor: '#fff',
                    color: '#333',
                    border: '1px solid #ddd',
                    fontWeight: '500'
                }}
            >
                ←
            </Button>
            <div
                style={{
                    borderRadius: '10px',
                    padding: '2.5rem',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
                    fontFamily: 'Arial, sans-serif'
                }}
            >
                <h2 style={{ fontWeight: 700, fontSize: '2rem', color: '#333' }}>{blogTitle}</h2>

                <img
                    src={blogImage4}
                    alt={blogTitle}
                    style={{
                        width: '100%',
                        maxHeight: '450px',
                        objectFit: 'contain',
                        objectPosition: 'left',
                        margin: '1.5rem 0'
                    }}
                />

                {/* Content Start */}
                <h5>Introduction</h5>
                <p>
                    In today’s digital age, your website is not just an online brochure. It’s your digital identity, your storefront, and often your first impression.
                    For small business owners in India, whether you run a kirana store in Bihar, a tailoring service in Madhya Pradesh, or a dairy farm in Gujarat, having a well-designed website is the key to growing beyond local boundaries.
                    <br /><br />
                    But just having a website is not enough. You need the right features to make it work for you.
                    <br /><br />
                    Come, let’s explore the top 10 must-have features for your small business website in 2025, especially tailored for Indian users.
                </p>

                <h5>1. Mobile‑First, Responsive Design 📱</h5>
                <p>
                    Most people in India browse using only mobile phones. In fact, over 60% of traffic comes from mobiles.
                    That means your website must work perfectly on smartphones.
                    <br /><br />
                    <strong>Why it matters:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Most people in Tier 2 and Tier 3 cities use budget smartphones.<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>If your site doesn’t look good or load properly, users leave instantly.
                    <br /><br />
                    <strong>How to do it?</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Use a responsive design (mobile-first layout) that adjusts automatically to any screen size.<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Make buttons large enough to tap easily (min. 44×44 px).<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Avoid pop-ups or elements that block content.<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Test on real phones and tablets.
                    <br /><br />
                    <strong>Benefits:</strong> Better Google ranking. More visitors can use your site easily.
                    <br />
                    <strong>Pro Tip:</strong> The Digital India App automatically provides mobile-optimized templates.
                </p>

                <h5>2. Fast Loading Speed ⚡</h5>
                <p>
                    If your website takes more than 3 seconds to load, you lose visitors. Studies prove it.
                    <br /><br />
                    <strong>What slows your site down?</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Large images<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Unnecessary plugins<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Uncompressed code
                    <br /><br />
                    <strong>How to speed up?</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Compress images (JPEG/WEBP)<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Use browser caching & CDN<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Minify CSS/JS files<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Use Google PageSpeed Insights<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Choose lightweight themes
                    <br /><br />
                    <strong>Benefits:</strong> Happier Visitors, Better SEO, More Conversions.
                </p>

                <h5>3. Clear, Actionable CTAs 🎯</h5>
                <p>
                    <strong>Examples:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Call Now for a Free Quote<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Book Your Order Online<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>WhatsApp Us to Know More<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Get a Free Quote
                    <br /><br />
                    <strong>Placement:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Top banner<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Middle of the page<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>End of blogs<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Floating buttons
                    <br /><br />
                    <strong>Add On:</strong> With Digital India, you can add click-to-call, WhatsApp, and booking buttons with zero coding.
                </p>

                <h5>4. Simple and Intuitive Navigation 🧭</h5>
                <p>
                    <strong>Do this:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Keep only 5–7 menu items<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Include “Home”, “About”, “Services”, “Blog”, “Contact”<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Add search bar and dropdowns
                    <br /><br />
                    <strong>Avoid:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Overcrowding<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Fancy/confusing animations<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Hiding info behind too many clicks
                </p>

                <h5>5. Trust Signals: SSL, Reviews, Testimonials 🔐</h5>
                <p>
                    <strong>Must-haves:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>SSL certificate (https://)<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Real reviews and testimonials<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Business registration info<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Google/Facebook ratings
                    <br /><br />
                    <strong>Bonus Tip:</strong> Add a “Why Trust Us” section.
                </p>

                <h5>6. Seamless Contact Options 📞</h5>
                <p>
                    <strong>Features:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Clickable phone<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>WhatsApp button<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Contact form<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Email address<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Live chat widget
                    <br /><br />
                    Add in: Header, Footer, Contact Page, Product pages.
                    <br />
                    <strong>Bonus:</strong> Map integration.
                </p>

                <h5>7. SEO‑Optimized On‑Page Content 🔍</h5>
                <p>
                    <strong>Do this:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Use keywords (e.g., “tailoring shop in Jabalpur”)<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Add keywords in title, meta, headings<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Clean URLs: /organic-honey<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Add alt text, short paragraphs, bullets<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Add blog and FAQs
                </p>

                <h5>8. Blog or Resource Section ✍️</h5>
                <p>
                    <strong>Post ideas:</strong><br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Tips & tricks<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Behind the scenes<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Customer stories<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Product launches
                    <br /><br />
                    <strong>Benefits:</strong> Trust, better SEO, more keywords.
                </p>

                <h5>9. Payment Integration & E‑commerce 💳</h5>
                <p>
                    <strong>Gateways:</strong> UPI, Paytm, Razorpay, Netbanking<br />
                    <strong>Features:</strong> Cart, Checkout, Order confirmation, COD, Refund/Return, Tracking
                    <br /><br />
                    <strong>Benefits:</strong> Direct sales and bookings on your site.
                </p>

                <h5>10. Live Chat or AI Chatbots 💬</h5>
                <p>
                    <strong>Tools:</strong> WhatsApp plugins, Zoho Chat, Messenger<br />
                    <strong>Chat Features:</strong> FAQs, lead capture, auto-reply
                    <br /><br />
                    <strong>Benefits:</strong> 24x7 support, instant replies.
                </p>

                <h5>Bonus Features (Highly Recommended)</h5>
                <ul>
                    <li>🔎 Google Analytics Integration</li>
                    <li>🌍 Multilingual Support</li>
                    <li>📹 Embedded Videos</li>
                    <li>🔗 Social Media Links</li>
                    <li>♿ Accessibility features</li>
                </ul>
                <br />
                <h5>The Big Question <span style={{fontSize: 20, marginRight: 10 }}> • </span>How to Implement Features in the Digital India App?</h5>
                <p>
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Templates with mobile-friendly layouts<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>SSL, hosting, SEO tools built-in<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Blog & Payment plugins<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Live Chat and Analytics<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>Multilingual support<br />
                    <span style={{fontSize: 20, marginRight: 10 }}> • </span>All in a few clicks, no coding needed
                </p>

                <h5>Conclusion</h5>
                <p>
                    Your small business website needs the right features to grow. Mobile-first design, fast loading, clear CTAs, trust signals, SEO, payments, chat—everything matters.
                    <br /><br />
                    Using Digital India, you can build a powerful, professional site in minutes.
                    <br />
                    No coding. No tech headaches.
                    <br /><br />
                    Apna business website ab sirf ek click door hai.
                    <br /><br />
                    👉 Use Digital India App to create your small business website today — quick, easy, and made for Bharat!
                </p>
                {/* Content End */}
            </div>
        </Container>
    );
};

export default BlogDetailPage2;
